import { cplatWorkerApi } from '@/api';
import { AxiosError } from 'axios';
import type {
  DailyNewsSummaryRequest,
  DailyNewsSummaryItem,
  DailyNewsSummaryResponse,
} from '@/types/api';

export const getDailyNewsSummary = async (
  request: DailyNewsSummaryRequest,
  signal?: AbortSignal,
): Promise<DailyNewsSummaryItem[]> => {
  try {
    const formattedDate = request.date.replace(/-/g, '/'); // "2025-05-20" → "2025/05/20"

    const res = await cplatWorkerApi.post<DailyNewsSummaryResponse>(
      '/api/news_clipping/get_daily_summary',
      {
        base_date: formattedDate,
      },
      { signal },
    );

    if (!res.data || res.data.code !== 200 || !Array.isArray(res.data.data)) {
      throw {
        code: res.data.code ?? 500,
        message: res.data.message || '뉴스 요약 데이터를 불러올 수 없습니다.',
      };
    }

    return res.data.data;
  } catch (error: unknown) {
    console.error('뉴스 요약 API 오류:', error);

    let customError = {
      code: 500,
      message: '뉴스 요약 데이터를 불러오는 중 오류가 발생했습니다.',
    };

    if (error instanceof AxiosError) {
      customError = {
        code: error.response?.data?.code ?? 500,
        message: error.response?.data?.message || '뉴스 요약 API에서 오류가 발생했습니다.',
      };
    } else if (
      typeof error === 'object' &&
      error !== null &&
      'code' in error &&
      'message' in error
    ) {
      customError = {
        code: (error as any).code,
        message: (error as any).message,
      };
    } else if (error instanceof Error) {
      customError = {
        code: 500,
        message: error.message,
      };
    }

    throw customError;
  }
};
